var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 4.75H11.25V3.5C11.25 2.63805 10.9076 1.8114 10.2981 1.2019C9.6886 0.59241 8.86195 0.25 8 0.25C7.13805 0.25 6.3114 0.59241 5.7019 1.2019C5.09241 1.8114 4.75 2.63805 4.75 3.5V4.75H3C2.66848 4.75 2.35054 4.8817 2.11612 5.11612C1.8817 5.35054 1.75 5.66848 1.75 6V13C1.75 13.3315 1.8817 13.6495 2.11612 13.8839C2.35054 14.1183 2.66848 14.25 3 14.25H13C13.3315 14.25 13.6495 14.1183 13.8839 13.8839C14.1183 13.6495 14.25 13.3315 14.25 13V6C14.25 5.66848 14.1183 5.35054 13.8839 5.11612C13.6495 4.8817 13.3315 4.75 13 4.75ZM6.25 3.5C6.25 3.03587 6.43437 2.59075 6.76256 2.26256C7.09075 1.93437 7.53587 1.75 8 1.75C8.46413 1.75 8.90925 1.93437 9.23744 2.26256C9.56563 2.59075 9.75 3.03587 9.75 3.5V4.75H6.25V3.5ZM12.75 12.75H3.25V6.25H12.75V12.75ZM9 9.5C9 9.69778 8.94135 9.89112 8.83147 10.0556C8.72159 10.22 8.56541 10.3482 8.38268 10.4239C8.19996 10.4996 7.99889 10.5194 7.80491 10.4808C7.61093 10.4422 7.43275 10.347 7.29289 10.2071C7.15304 10.0673 7.0578 9.88907 7.01921 9.69509C6.98063 9.50111 7.00043 9.30004 7.07612 9.11732C7.15181 8.93459 7.27998 8.77841 7.44443 8.66853C7.60888 8.55865 7.80222 8.5 8 8.5C8.26522 8.5 8.51957 8.60536 8.70711 8.79289C8.89464 8.98043 9 9.23478 9 9.5Z",
    fill: "#004A99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.15244f6a13e82b0c4ca2895916c8c592.svg";
export { ForwardRef as ReactComponent };